/** Emoji inserted into the message text. WhatsApp sends them as part of the text. */
export const EMOJI_GROUPS = [
  {
    id: 'smile',
    label: 'Smileys',
    icon: '😀',
    emojis: [
      ['😀', 'grin smile happy'],
      ['😃', 'smile happy'],
      ['😄', 'smile happy'],
      ['😁', 'grin'],
      ['😆', 'laugh'],
      ['😅', 'sweat laugh'],
      ['😂', 'joy laugh'],
      ['🤣', 'rofl laugh'],
      ['🙂', 'smile'],
      ['😉', 'wink'],
      ['😊', 'blush smile'],
      ['😇', 'angel'],
      ['🥰', 'love smile'],
      ['😍', 'heart eyes love'],
      ['🤩', 'star eyes'],
      ['😘', 'kiss'],
      ['😗', 'kiss'],
      ['😚', 'kiss'],
      ['😋', 'yum'],
      ['😛', 'tongue'],
      ['😜', 'wink tongue'],
      ['🤪', 'zany'],
      ['😝', 'tongue'],
      ['🤗', 'hug'],
      ['🤭', 'giggle'],
      ['🤔', 'think'],
      ['😐', 'neutral'],
      ['😑', 'expressionless'],
      ['😏', 'smirk'],
      ['😒', 'unamused'],
      ['🙄', 'roll eyes'],
      ['😬', 'grimace'],
      ['😌', 'relieved'],
      ['😔', 'sad'],
      ['😪', 'sleepy'],
      ['😴', 'sleep'],
      ['😷', 'mask sick'],
      ['🤒', 'sick'],
      ['🤕', 'hurt'],
      ['🤢', 'sick'],
      ['🥵', 'hot'],
      ['🥶', 'cold'],
      ['😎', 'cool sunglasses'],
      ['🤓', 'nerd'],
      ['😕', 'confused'],
      ['😟', 'worried'],
      ['😮', 'surprised wow'],
      ['😲', 'astonished'],
      ['😳', 'flushed'],
      ['🥺', 'pleading'],
      ['😢', 'cry sad'],
      ['😭', 'sob cry'],
      ['😱', 'scream'],
      ['😤', 'triumph'],
      ['😡', 'angry'],
      ['😠', 'angry'],
      ['🤬', 'swear angry'],
      ['🤯', 'mind blown'],
      ['🥳', 'party'],
      ['😈', 'devil'],
      ['💀', 'skull'],
      ['💩', 'poop'],
      ['🤡', 'clown'],
      ['👻', 'ghost'],
    ],
  },
  {
    id: 'gesture',
    label: 'Gestures',
    icon: '👍',
    emojis: [
      ['👍', 'thumbs up yes ok'],
      ['👎', 'thumbs down no'],
      ['👌', 'ok'],
      ['✌️', 'victory peace'],
      ['🤞', 'fingers crossed luck'],
      ['🤟', 'love you'],
      ['🤘', 'rock'],
      ['👏', 'clap'],
      ['🙌', 'hooray'],
      ['👐', 'open hands'],
      ['🤲', 'palms'],
      ['🤝', 'handshake'],
      ['🙏', 'please thanks pray'],
      ['✍️', 'write'],
      ['💪', 'strong'],
      ['👋', 'wave hello bye'],
      ['🤚', 'hand'],
      ['✋', 'stop hand'],
      ['👊', 'fist'],
      ['✊', 'fist'],
      ['🤛', 'fist'],
      ['🤜', 'fist'],
    ],
  },
  {
    id: 'heart',
    label: 'Hearts',
    icon: '❤️',
    emojis: [
      ['❤️', 'heart love red'],
      ['🧡', 'heart orange'],
      ['💛', 'heart yellow'],
      ['💚', 'heart green'],
      ['💙', 'heart blue'],
      ['💜', 'heart purple'],
      ['🖤', 'heart black'],
      ['🤍', 'heart white'],
      ['🤎', 'heart brown'],
      ['💔', 'broken heart'],
      ['❣️', 'heart'],
      ['💕', 'hearts love'],
      ['💞', 'hearts'],
      ['💓', 'heartbeat'],
      ['💗', 'heart'],
      ['💖', 'sparkle heart'],
      ['💘', 'cupid'],
      ['💝', 'heart gift'],
      ['💟', 'heart'],
    ],
  },
  {
    id: 'object',
    label: 'Objects',
    icon: '📎',
    emojis: [
      ['🔥', 'fire'],
      ['✨', 'sparkle'],
      ['⭐', 'star'],
      ['🌟', 'star'],
      ['💯', 'hundred'],
      ['✅', 'check yes done'],
      ['❌', 'cross no'],
      ['⚠️', 'warning'],
      ['📌', 'pin'],
      ['📎', 'paperclip'],
      ['📁', 'folder'],
      ['📂', 'folder'],
      ['📄', 'file document'],
      ['📝', 'memo note'],
      ['📅', 'calendar'],
      ['📞', 'phone call'],
      ['📱', 'mobile'],
      ['💻', 'laptop'],
      ['📷', 'camera photo'],
      ['🎥', 'video'],
      ['🎵', 'music'],
      ['🔔', 'bell'],
      ['🎉', 'party'],
      ['🎁', 'gift'],
      ['🏆', 'trophy'],
      ['💡', 'idea'],
      ['🔒', 'lock'],
      ['🔑', 'key'],
      ['🏠', 'home'],
      ['🏫', 'school'],
      ['📚', 'books'],
      ['✏️', 'pencil'],
      ['⏰', 'clock time'],
      ['⌛', 'hourglass'],
      ['💰', 'money'],
      ['💵', 'money'],
      ['💳', 'card'],
      ['🧾', 'receipt'],
    ],
  },
];

export function filterEmojis(query) {
  const q = String(query || '').trim().toLowerCase();
  if (!q) return EMOJI_GROUPS;
  return EMOJI_GROUPS.map((group) => ({
    ...group,
    emojis: group.emojis.filter(([emoji, keywords]) => (
      emoji.includes(q) || keywords.includes(q) || group.label.toLowerCase().includes(q)
    )),
  })).filter((group) => group.emojis.length);
}
